export const CurrentUserAction = {
    GET_ME: 'GET_ME',
    GET_ME_SUCCESS: 'GET_ME_SUCCESS',
};
